import React from "react";

export default function DeficiencyFields({
  value,
  update,
  errors = {},
  severityControl = null,
  selectorOnly = false,
  hideSelector = false,
}) {
  const choice = (key, label) => (
    <label key={key}>
      {label}
      <select
        aria-label={label}
        value={value[key] == null ? "" : String(value[key])}
        onChange={(event) =>
          update({
            [key]:
              event.target.value === "" ? null : event.target.value === "true",
          })
        }
      >
        <option value="">Select</option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
      {errors[key] && <small role="alert">{errors[key]}</small>}
    </label>
  );
  const text = (key, label, required = false) => (
    <label key={key}>
      <span>{label}{required && <em aria-hidden="true"> *</em>}</span>
      <textarea
        aria-label={label}
        required={required}
        value={value[key] || ""}
        onChange={(event) => update({ [key]: event.target.value })}
      />
      {errors[key] && <small role="alert">{errors[key]}</small>}
    </label>
  );
  return (
    <section className="deficiency-fields">
      {!hideSelector && (
        <label>
          Deficiency exists?
          <select
            aria-label="Deficiency exists?"
            value={
              value.deficiencyExists == null
                ? ""
                : String(value.deficiencyExists)
            }
            onChange={(event) =>
              update({
                deficiencyExists:
                  event.target.value === ""
                    ? null
                    : event.target.value === "true",
              })
            }
          >
            <option value="">Select</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          {errors.deficiencyExists && (
            <small role="alert">{errors.deficiencyExists}</small>
          )}
        </label>
      )}
      {!selectorOnly && value.deficiencyExists === true && (
        <>
          {text("rootCause", "Root cause", true)}
          <div className="deficiency-fields__severity">
            {choice("isSevere", "Is the deficiency severe?")}
            {value.isSevere === true && severityControl}
          </div>
          {choice("isPervasive", "Is the deficiency pervasive?")}
          {text("remediationActionPlan", "Document remediation action plan", true)}
          {choice(
            "remedialActionsEffective",
            "Were remedial actions taken and effective?"
          )}
          {value.remedialActionsEffective && (
            <label>
              Remedial actions date
              <input
                aria-label="Remedial actions date"
                type="date"
                value={value.remedialActionsDate || ""}
                onChange={(event) =>
                  update({
                    remedialActionsDate: event.target.value,
                    ...(value.findingResolved && !value.findingResolvedDate
                      ? { findingResolvedDate: event.target.value }
                      : {}),
                  })
                }
              />
              {errors.remedialActionsDate && (
                <small role="alert">{errors.remedialActionsDate}</small>
              )}
            </label>
          )}
          {text(
            "remedialActionsComments",
            "Additional comments on remedial actions"
          )}
          {choice("findingResolved", "Is the finding resolved?")}
          {value.findingResolved && (
            <label>
              Finding resolved date
              <input
                aria-label="Finding resolved date"
                type="date"
                value={
                  value.findingResolvedDate ||
                  (value.remedialActionsEffective === true
                    ? value.remedialActionsDate
                    : "") ||
                  ""
                }
                onChange={(event) =>
                  update({ findingResolvedDate: event.target.value })
                }
              />
              {errors.findingResolvedDate && (
                <small role="alert">{errors.findingResolvedDate}</small>
              )}
            </label>
          )}
          {text(
            "findingResolutionComments",
            "Additional comments on resolution"
          )}
        </>
      )}
    </section>
  );
}
